module.exports = __webpack_public_path__ + "img/you.7af36dd4.png";